var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Icon',_vm._g(_vm._b({attrs:{"icon":_vm.icon,"inline":_vm.inline,"width":_vm.width,"height":_vm.height,"color":_vm.color,"rotate":_vm.rotate,"flip":_vm.flip,"horizontalFlip":_vm.horizontalFlip,"verticalFlip":_vm.verticalFlip}},'Icon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }